<template>
  <div>
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane
        :label="$l('INDEX.card_basicInformation') || '基础信息'"
        name="base"
      >
        <scm-base
          :scmCode="curScmCode"
          :pageType="this.pageType"
          :diversity="params.diversity"
          @saveSuccess="saveSuccess"
          ref="scmBase"
        />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.card_contact_information') || '联系人信息'"
        name="contact"
        :disabled="isDisabled"
      >
        <contacts :scmCode="curScmCode" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.card_file_information') || '文件信息'"
        name="images"
        :disabled="isDisabled"
      >
        <images-table :scmCode="curScmCode" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.card_visit_record') || '拜访记录'"
        name="visit"
        :disabled="isDisabled"
      >
        <visit :scmCode="curScmCode" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.card_scoring_record') || '评分记录'"
        name="scores"
        :disabled="isDisabled"
      >
        <score-table :scmCode="curScmCode" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import ScmBase from './components/scm-base.vue'
import Contacts from './components/contacts'
import ImagesTable from './components/images-table'
import Visit from './components/visit'
import ScoreTable from './components/score-table'
import { mapActions } from 'vuex'
export default {
  name: 'resourceManagement-scmInfoTemp',
  components: {
    ScmBase,
    Contacts,
    ImagesTable,
    Visit,
    ScoreTable,
  },
  data() {
    return {
      activeName: 'base',
      scmMode: '',
      curScmCode: '',
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    // 是否禁用表单
    isDisabled() {
      return this.pageType === 'add' && !this.curScmCode
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    init() {
      this.curScmCode = this.params.scmCode
    },
    saveSuccess(scmCode) {
      this.curScmCode = scmCode
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
